<template>
  <div class="footer">
    <slot name="footer-service">
      <ul class="layout-content">
        <li class="theme">
          <div class="logo">
            <img src="../../../assets/img/logo.png" alt="logo" />
            <p>促进软件开发领域知识与创新的传播</p>
          </div>
          <dl>
            <dt>商务专区</dt>
            <dd>
              <ul>
                <li v-for="(item, index) in bus" :key="index">
                  <a :href="item.link" target="_blank" rel="noopener nofollow">{{item.name}}</a>
                </li>
              </ul>
            </dd>
          </dl>
        </li>
        
        <li v-for="(item, index) in nav" :key="index">
          <dl class="footer-nav">
            <dt>{{item.name}}</dt>
            <dd v-for="(link, i) in item.list" :key="i">
              <img :src="link.image" v-if="link.image" alt="会议图片" />
              <a :href="link.link" target="_blank" rel="noopener nofollow" v-if="link.link">{{link.name}}</a>
              <span v-else>{{link.name}}</span>
            </dd>
          </dl>
        </li>
      </ul>
    </slot>

    <!-- <div class="copyright">
      Copyright © {{(new Date()).getFullYear()}}, Geekbang Technology Ltd. All rights reserved. 极客邦控股（北京）有限公司 | 京 ICP 备 16027448 号 - 5
      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502039052">
        <img src="../../../assets/img/beian.png" alt="京公网安备" />
        <span>京公网安备 11010502039052号</span>
      </a>
    </div> -->
  </div>
</template>

<script>

export default {
  name: 'footer-pc',
  components: {
  },
  props: {
    user: {
      type: [Object, undefined]
    },
    /**
     * 底部商业导航
     */
    bus: {
      type: Array,
      default: () => []
    },
    /**
     * 底部导航
     */
    nav: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  created () {},
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/common';

.footer {
  width: 100%;
  background: #FFF;
  border-top: 1px solid $borderGray;

  & > ul {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    // height: 240px;
    padding: 48px 0 37px;
  }
}

.theme {
  flex: 310px 0 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  & .logo {
    & img {
      display: block;
      height: 28px;
      margin-left: 1px;
    }

    & p {
      padding-top: 15px;
      @include lineFont(12, 400);
    }
  }

  & dl {
    padding-top: 25px;
  }
  & dt {
    padding-bottom: 2px;
    @include font(16, 400);
    color: $black;
  }
  & dd {
    line-height: 24px;
    @include font(12, 400);
    color: #6B6E75;
  }
  & ul {
    display: flex;
    flex-wrap: wrap;
    margin-left: -10px;
  }
  & li {
    margin: 0 10px;

    & a {
      color: #6B6E75;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
        color: $blue;
      }
    }
  }
}

.footer-nav {
  padding-top: 9px;
  
  & dt {
    margin-bottom: 11px;
    @include lineFont(16, 400);
    color: $black;
  }
  & dd {
    display: flex;
    line-height: 24px;
    @include font(12, 400);
    color: #6B6E75;

    & img {
      position: relative; top: 5px;
      display: block;
      height: 13px;
      margin: 0 4px 0 2px;
    }

    & a,
    & span {
      color: #6B6E75;
    }

    & a:hover {
      text-decoration: underline;
      color: $blue;
    }
  }
}

.copyright {
  @extend %center;
  width: 100%; height: 60px;
  background: #646D7D;
  text-align: center;
  @extend %font12;
  color: #D1D6E1;

  & img {
    margin-left: 15px;
    vertical-align: top;
  }

  & span {
    padding-left: 5px;
    color: #D1D6E1;
  }
}
</style>
